(() => {
  function ready() {
    if (!document.querySelector('pugs-app-size-chart') || customElements.get('pugs-app-size-chart')) return;
    const source = [...document.scripts].find(s => (s.src || s.dataset.src || '').split('?')[0].endsWith('/size-chart.js'));
    if (!source || document.getElementById('fshop-chart-app-loader')) return;
    const script = document.createElement('script');
    script.id = 'fshop-chart-app-loader';
    script.src = source.src || source.dataset.src;
    document.head.append(script);
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', ready, {once:true});
  else ready();
  document.addEventListener('shopify:section:load', ready);
})();
